/** Tenant/company chrome for participant pages. Classic 5X keeps #004f73. */

export const DEFAULT_BRAND_COLOR = "#004f73";

const HEX = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export function brandColor(branding) {
  const raw = typeof branding?.primary_color === "string" ? branding.primary_color.trim() : "";
  return HEX.test(raw) ? raw : DEFAULT_BRAND_COLOR;
}

export function brandCssVars(branding) {
  const color = brandColor(branding);
  return {
    "--brand-primary": color,
  };
}

export function usesFiveXBranding(branding, assessmentType) {
  if (branding?.email_pack === "generic" || branding?.tenant_id) return false;
  if (assessmentType?.uses_five_x_branding === false) return false;
  return true;
}
